import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../lib/supabaseClient";
import Icon from "components/AppIcon";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (error) throw error;

      // Redirect to admin dashboard on success
      navigate("/admin/dashboard");
    } catch (err) {
      setError(err.message || "Failed to login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-surface to-accent-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Logo/Title */}
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-primary rounded-xl flex items-center justify-center mx-auto mb-4 shadow-elevation-2">
            <Icon name="Shield" size={32} className="text-white" />
          </div>
          <h1 className="text-3xl font-heading-bold text-text-primary mb-2">
            Admin Portal
          </h1>
          <p className="text-text-secondary">
            FiberFlow Cost Calculator Administration
          </p>
        </div>

        {/* Login Form */}
        <div className="bg-surface rounded-xl shadow-elevation-2 p-8 border border-border">
          <form onSubmit={handleLogin} className="space-y-6">
            {/* Email Field */}
            <div className="space-y-2">
              <label
                htmlFor="email"
                className="block text-sm font-body-medium text-text-primary"
              >
                <div className="flex items-center space-x-2">
                  <Icon name="Mail" size={16} className="text-primary" />
                  <span>Email Address</span>
                </div>
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@example.com"
                required
                className="block w-full px-4 py-3 border border-border rounded-lg text-sm placeholder-text-tertiary focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition-all duration-150 bg-surface text-text-primary"
              />
            </div>

            {/* Password Field */}
            <div className="space-y-2">
              <label
                htmlFor="password"
                className="block text-sm font-body-medium text-text-primary"
              >
                <div className="flex items-center space-x-2">
                  <Icon name="Lock" size={16} className="text-primary" />
                  <span>Password</span>
                </div>
              </label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
                className="block w-full px-4 py-3 border border-border rounded-lg text-sm placeholder-text-tertiary focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary transition-all duration-150 bg-surface text-text-primary"
              />
            </div>

            {/* Error Message */}
            {error && (
              <div className="flex items-center space-x-2 p-3 bg-error-50 border border-error-200 rounded-lg text-sm text-error">
                <Icon name="AlertCircle" size={16} />
                <span>{error}</span>
              </div>
            )}

            {/* Submit Button */}
            <button
              type="submit"
              disabled={loading}
              className="w-full inline-flex items-center justify-center px-6 py-3 bg-primary text-white rounded-lg font-body-medium hover:bg-primary-600 transition-all duration-150 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed shadow-elevation-1"
            >
              {loading ? (
                <>
                  <div className="animate-spin mr-2">
                    <Icon name="Loader2" size={20} />
                  </div>
                  Signing in...
                </>
              ) : (
                <>
                  <Icon name="LogIn" size={20} className="mr-2" />
                  Sign In
                </>
              )}
            </button>
          </form>

          {/* Back to Home */}
          <div className="mt-6 text-center">
            <button
              onClick={() => navigate("/")}
              className="text-sm text-text-secondary hover:text-primary transition-colors duration-150 inline-flex items-center space-x-1"
            >
              <Icon name="ArrowLeft" size={14} />
              <span>Back to Calculator</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
